import { kohSamuiHotels } from '../../../config/affiliates/hotels/trip/samui';
import { Content } from '../../types';

const kohSamuiFamilyHotelsContent: Content = {
  title: 'מלונות מומלצים למשפחות בקו סאמוי',
  imageUrl:
    '/images/thailand/phuket-family-hotels/phuket-family-hotels-preview.jpg',
  introduction:
    'קו סאמוי, האי הקסום שבמזרח תאילנד, הוא יעד מושלם לחופשה משפחתית. האי משלב חופים ציוריים, אטרקציות לילדים, מסעדות נהדרות ושלל מלונות המתאימים בדיוק למשפחות המחפשות נוחות, כיף ורוגע.<br/ > כדי לעזור לכם לתכנן את החופשה המשפחתית הבאה, ריכזנו את המלונות המומלצים ביותר למשפחות בקו סאמוי, בהתאם לאזורי הלינה המומלצים.',
  sections: [
    {
      title: "צ'אוונג - מרכז העניינים עם חוף מהמם",
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Centara Reserve Samui',
          text: "מלון סנטארה הוא אחד המלונות האהובים על משפחות המחפשות גם יוקרה וגם נוחות.<br/>המלון ממוקם ממש על חוף צ'אוונג, מציע חדרים מרווחים, סוויטות עם בריכות פרטיות, מועדון ילדים מושקע עם פעילויות לכל גיל, בריכת ילדים גדולה ושירות חמים במיוחד.<br/>הקרבה למסעדות, חנויות ואטרקציות, הופכת אותו לבחירה מושלמת למשפחות המבקשות לשהות בלב העניינים.",
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> מומלץ לבדוק את סוויטות הגן - יש להן גישה ישירה לבריכה והן מרווחות במיוחד למשפחות.',
          link: {
            url: kohSamuiHotels['centara-reserve'],
            text: 'לחצו כאן ובדקו את Centara Reserve Samui בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Amari Koh Samui',
          text: 'מלון אמארי מציע אווירה חמימה ונעימה, המתאימה מאוד למשפחות.<br/>המלון בנוי סביב גנים ירוקים, עם שתי בריכות, מועדון ילדים צבעוני, גישה ישירה לחוף וחדרים משפחתיים מעוצבים ונוחים.<br/>חלקו של המלון הפונה לחוף, מופרד מהאגף השני על ידי כביש קטן, אך ישנו מעבר נוח בין החלקים.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> האגף הפונה לחוף שקט יותר ומתאים במיוחד למשפחות עם ילדים קטנים.',
          link: {
            url: kohSamuiHotels['amari-samui'],
            text: 'לחצו כאן ובדקו את Amari Koh Samui בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Chaweng Regent Beach Resort',
          text: "מחפשים מיקום מרכזי בלי לוותר על רוגע? צ'אוונג ריג'נט הוא הבחירה עבורכם.<br/>המלון ממוקם בלב האזור התוסס של צ'אוונג, אך מצליח לשמור על תחושת פרטיות ושלווה.<br/>הוא מציע שתי בריכות, חדרים משפחתיים עם מרפסות וגישה נוחה לכל מה שהאזור מציע - מסעדות, חנויות, שווקים ואטרקציות.",
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> צאו מהמלון ופנו שמאלה ותגיעו לדוכן השייקים הכי שווה באי.',
          link: {
            url: kohSamuiHotels['chaweng-regent'],
            text: 'לחצו כאן ובדקו את Chaweng Regent Beach Resort בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'בופוט - אווירה רגועה ואותנטית ליד כפר הדייגים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Holiday Inn Resort Samui Bophut Beach',
          text: 'מלון הולידיי אין בבופוט הוא גן עדן למשפחות.<br/>הוא ממוקם על חוף רחב ונעים, מציע בריכת ילדים עם מגלשות, מועדון ילדים מהמושקעים שיש לאי להציע, חדרים מותאמים למשפחות ואווירה רגועה.<br/>המלון צמוד לשוק הלילה אשר מתקיים בכפר הדייגים ארבע פעמים בשבוע. ',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> מומלץ להזמין חדר משפחה עם פינת ישיבה ומרפסת - יש בהם מרחב נעים להורים ולילדים.',
          link: {
            url: kohSamuiHotels['holiday-inn-bophut'],
            text: 'לחצו כאן ובדקו את Holiday Inn Resort Samui Bophut Beach בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Bandara Resort & Spa',
          text: 'מלון בנדרה מציע שילוב מוצלח של שקט, סטייל ונוחות עבור משפחות.<br/>המלון נמצא על חוף שקט במרחק הליכה מהשוק של כפר הדייגים, יש בו בריכות נפרדות למבוגרים ולילדים, מועדון ילדים קטן וחדרים עם אפשרות לדלת מקשרת.<br/>הספא והמסעדות במקום הם בונוס לא רע גם להורים המעוניינים ברגע של פינוק.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> משפחות רבות ממליצות על הווילות עם הבריכה הפרטית - חוויה מושלמת במחיר מפתיע.',
          link: {
            url: kohSamuiHotels['bandara-resort'],
            text: 'לחצו כאן ובדקו את Bandara Resort & Spa בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: "צ'אוונג מון - שקט, טבע וחופים רכים",
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Melia Koh Samui',
          text: 'מלון מליה בקצה הצפוני של קוסמוי הוא חלום עבור משפחות המחפשות איכות, שקט ומרחב.<br/>המלון מציע בריכות מפותלות, מועדון ילדים מושקע מאוד, חדרים מרווחים עם עיצוב מודרני וגם מגלשה גדולה לבריכת הילדים.<br/>החוף באזור רגוע ונעים, במיוחד עבור ילדים קטנים.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> מומלץ לבדוק את סוויטות ה־Family Room - יש בהן פינת ילדים ייחודית בצורת סירה!',
          link: {
            url: kohSamuiHotels['melia-samui'],
            text: 'לחצו כאן ובדקו את Melia Koh Samui בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Kimpton Kitalay Samui',
          text: 'אחד המלונות החדשים והמעוצבים ביותר באי, מתאים מאוד למשפחות המחפשות יוקרה קצת אחרת.<br/>העיצוב במלון עוצר נשימה והחוויה כולה מוקפדת לפרטים הקטנים ובכלל זה, מועדון ילדים מעוצב כעולם קטן, חדרים עם אמבטיות ענקיות ושירות בלתי רגיל.<br/>החוף שקט ונקי ויש לא מעט פינות צל ומנוחה מסביב לבריכה.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> בקשו את חדרי ה־Premier Family עם מרפסת - הם גדולים ומתוכננים במיוחד למשפחות עם ילדים.',
          link: {
            url: kohSamuiHotels['kimpton-kitalay'],
            text: 'לחצו כאן ובדקו את Kimpton Kitalay Samui בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'למאי - משפחות שאוהבות חופים עם אופי',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Silavadee Pool Spa Resort',
          text: 'מלון סילאוואדי מציע חוויה שקטה ויוקרתית, עם נוף מהמם לים ומתאים למשפחות עם ילדים בוגרים יותר.<br/>תמצאו כאן סוויטות ווילות עם בריכות פרטיות, מסעדה מעולה, שירות ברמה גבוהה ונוף פנורמי עוצר נשימה.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> ישנן וילות משפחתיות עם שתי קומות ובריכה פרטית - חוויה מושלמת למשפחות של עד 5-6 נפשות.',
          link: {
            url: kohSamuiHotels['silavadee'],
            text: 'לחצו כאן ובדקו את Silavadee Pool Spa Resort בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Outrigger Koh Samui Beach Resort',
          text: 'מלון מעולה עבור משפחות - עם מועדון ילדים מרשים, חדרים עם יציאה לבריכה, מסעדות מגוונות ופעילויות מים.<br/>החוף עצמו נעים והאזור של למאי מציע גם שוק לילה, מופעי קופים ואטרקציות קלות ליום של טיול.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> מומלץ לבדוק את האפשרות לקבל חדר עם מטבחון קטן - שימושי מאוד למשפחות עם ילדים קטנים.',
          link: {
            url: kohSamuiHotels['outrigger-samui'],
            text: 'לחצו כאן ובדקו את Outrigger Koh Samui Beach Resort בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Pavilion Samui Villas & Resort',
          text: "מלון יוקרה עם טאץ' מקומי, הנמצא ממש על חוף למאי.<br/>הווילות המשפחתיות מצוידות בבריכה פרטית, יש בריכת ילדים, מועדון ילדים קטן ואפשרות לטיפולים זוגיים בזמן שהילדים עסוקים.",
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> החוף שליד המלון שקט במיוחד - אידיאלי לשחייה בטוחה אף לקטנטנים.',
          link: {
            url: kohSamuiHotels['pavilion-samui'],
            text: 'לחצו כאן ובדקו את Pavilion Samui Villas & Resort בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'לסיכום',
      type: 'text',
      content:
        'קו סאמוי מציעה שילוב נהדר של יופי, אטרקציות ומלונות המתאימים בדיוק לצרכים של משפחות - בין אם אתם מחפשים שלווה, הרפתקאה, יוקרה או נוחות.<br/>בחרו את האזור שהכי מתאים לכם ואל תשכחו להשאיר זמן גם לרוגע בין כל הפעילויות.<br/><strong>אם אתם מתלבטים מהו המלון שהכי מתאים עבורכם - אל תהססו לפנות אלינו באמצעות עמוד "צור קשר" ונשמח לעזור לכם לתכנן את החופשה המושלמת.</strong>',
      sectionLink: {
        url: '/contact',
        text: 'צור קשר לקבלת סיוע בבחירת המלון המושלם',
      },
    },
  ],
};

export default kohSamuiFamilyHotelsContent;
